import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import {
  Button,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Placeholder,
  Container,
  Col,
  Row,
  Checkbox,
  Modal,
  useToaster,
  Uploader,
  Message,
  Loader,
  RadioGroup,
  Radio,
  CheckPicker,
  FlexboxGrid,
  Cascader,
  Whisper,
  Tooltip,
  IconButton,
  PanelGroup,
  Input,
  Form,
  Nav,
  SelectPicker,
  ButtonGroup
} from 'rsuite';

import { Link } from 'react-router-dom';
import globalIP from '@/GlobelIP';
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro';
import VisibleIcon from '@rsuite/icons/Visible';
import CataFormat1 from './CataFormat1';
import CataFormat2 from './CataFormat2';
import CataFormat3 from './CataFormat3';
import ugr from '@/UGRoute';

const CatalogueTemp = () => {
  const [activeKeymain, setActiveKeymain] = useState('content1');
  const handleNavSelectMain = eventKey => {
    setActiveKeymain(eventKey);
  };
  const [activeKeyside, setActiveKeyside] = useState('content1');
  const handleNavSelectside = eventKey => {
    setActiveKeyside(eventKey);
  };
  const [activeKeyunder, setActiveKeyunder] = useState('content1');
  const handleNavSelectunder = eventKey => {
    setActiveKeyunder(eventKey);
  };
  const data = ['Regular', 'Buyer'].map(item => ({ label: item, value: item }));
  const [buyertype, setBuyerType] = useState('Regular');
  const [buyerName, setBuyerName] = useState('');

  const [fileInfo1, setFileInfo1] = useState({
    PPT_coverpage: null,
    PPT_footerpage: null,
    PDF_coverpageH: null,
    PDF_footerpageH: null,
    PDF_coverpageV: null,
    PDF_footerpageV: null,
    excel_banner: null
  });
  const handleImageUpload = (fileList, key) => { };
  const [buyeerdata, setBuyeerdata] = useState([]);
  useEffect(() => {
    fetchDatab();
  }, []);
  const fetchDatab = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/buyer-details?populate=*&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const processedData = json.data.map(item => ({
        label: item.attributes.buyernm,
        value: item.attributes.buyercode
      }));
      setBuyeerdata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const handlechange = value => {
    setBuyerType(value);
    if (value == 'Regular') {
      setBuyerName('');
    }
  };
  return (
    <>
      <Container className="main">
        <div
          style={{
            justifyContent: 'space-between',
            width: '-webkit-fill-available',
            position: 'fixed',
            height: '180px',
            background: '#fff',
            zIndex: 1
          }}
        >
          <Stack className="table-toolbar" justifyContent="space-between" alignItems="flex-end">
            <Stack direction="column" alignItems="flex-start">
              <Stack direction="column" alignItems="flex-start">
                <h3 className="title">Templates Library</h3>
                <Breadcrumb>
                  <Breadcrumb.Item>
                    <Link to={`/${ugr}/dashboard`}>Home</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>Templates</Breadcrumb.Item>
                </Breadcrumb>
              </Stack>
              <Stack spacing={15}>
                <Nav
                  activeKey={activeKeymain}
                  onSelect={handleNavSelectMain}
                  appearance="subtle"
                  style={{ display: 'flex', gap: '10px' }}
                >
                  <Nav.Item eventKey="content1">Catalogue</Nav.Item>
                  <Nav.Item eventKey="content2">Quotation</Nav.Item>
                  <Nav.Item eventKey="content3">E-Markering</Nav.Item>
                  {/* <Nav.Item eventKey="content4">Email</Nav.Item> */}
                </Nav>
                <div id="custom-container" style={{ position: 'relative' }}>
                  <SelectPicker
                    data={data}
                    searchable={false}
                    cleanable={false}
                    value={buyertype}
                    onChange={value => handlechange(value)}
                    style={{ width: 145 }}
                    placeholder="Select "
                    container={() => document.getElementById('custom-container')}
                  />
                </div>
                <div id="custom-container" style={{ position: 'relative' }}>
                  {buyertype === 'Buyer' && (
                    <SelectPicker
                      data={buyeerdata}
                      onChange={value => setBuyerName(value)}
                      style={{ width: 145 }}
                      placeholder="Buyer"
                      container={() => document.getElementById('custom-container')}
                    />
                  )}
                </div>
              </Stack>
            </Stack>
          </Stack>
          <Divider className="divide" style={{ marginTop: '10px', marginBottom: '10px' }} />
        </div>
        <div style={{ marginTop: '190px' }}>

          <FlexboxGrid>
            <FlexboxGrid.Item colspan={20}>
              {activeKeymain === 'content1' && (
                <CataFormat1
                  activeKeyside={activeKeyside}
                  buyertype={buyertype}
                  buyerName={buyerName}
                />
              )}
              {activeKeymain === 'content2' && (
                <CataFormat2 buyertype={buyertype} buyerName={buyerName} />
              )}
              {activeKeymain === 'content3' && (
                <CataFormat3
                  activeKeyside={activeKeyside}
                  buyertype={buyertype}
                  buyerName={buyerName}
                />
              )}
            </FlexboxGrid.Item>
            {activeKeymain !== 'content4' &&
              <FlexboxGrid.Item colspan={4}>
                <Panel>
                  <Nav
                    activeKey={activeKeyside}
                    onSelect={handleNavSelectside}
                    appearance="subtle"
                    vertical
                    reversed
                    style={{ gap: '10px', zIndex: 0 }}
                  >
                    {activeKeymain !== 'content2' && (
                      <>
                        <Nav.Item eventKey="content1">PPT</Nav.Item>
                        <Nav.Item eventKey="content2">PDF</Nav.Item>
                      </>
                    )}
                    <Nav.Item eventKey="content3">Excel</Nav.Item>
                  </Nav>
                </Panel>
              </FlexboxGrid.Item>
            }
          </FlexboxGrid>
        </div>

        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERP Daddy Softwere Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};
export default CatalogueTemp;
